import { ArrowBackIosNew } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useLocation } from 'react-router-dom';

export const MobileMenuHeader = () => {
  const { t } = useTranslation();
  const location = useLocation();

  if (location.pathname === '/') return null;

  return (
    <Box p={2} display={{ sm: 'none' }}>
      <Button
        color="secondary"
        size="small"
        component={RouterLink}
        to="/"
        startIcon={<ArrowBackIosNew />}
      >
        {t('backToMenu')}
      </Button>
    </Box>
  );
};
